/* Product gallery: smooth hover zoom (1.5x) that follows the cursor. Mouse / trackpad only. */
(function () {
  if (!window.matchMedia || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  var SCALE = 1.5;
  var style = document.createElement('style');
  style.textContent =
    '.pp-gal .gallery__slide.pp-zoomable{overflow:hidden;cursor:zoom-in}' +
    '.pp-gal .gallery__slide.pp-zoomable>img{transform-origin:50% 50%;transition:transform .5s cubic-bezier(.22,.61,.36,1),transform-origin .2s ease-out;will-change:transform}' +
    '.pp-gal .gallery__slide.is-zooming>img{transform:scale(' + SCALE + ')}' +
    '@media (prefers-reduced-motion: reduce){.pp-gal .gallery__slide.pp-zoomable>img{transition:none}}';
  document.head.appendChild(style);

  function bind(slide) {
    if (slide.dataset.ppZoom) return;
    var img = slide.querySelector(':scope > img');
    if (!img) return;
    slide.dataset.ppZoom = '1';
    slide.classList.add('pp-zoomable');
    var raf = 0, px = 50, py = 50;
    function apply() { raf = 0; img.style.transformOrigin = px + '% ' + py + '%'; }
    function move(e) {
      var r = img.getBoundingClientRect();
      if (!r.width || !r.height) return;
      px = Math.min(100, Math.max(0, (e.clientX - r.left) / r.width * 100));
      py = Math.min(100, Math.max(0, (e.clientY - r.top) / r.height * 100));
      if (!raf) raf = requestAnimationFrame(apply);
    }
    slide.addEventListener('pointerenter', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      move(e); apply(); slide.classList.add('is-zooming');
    });
    slide.addEventListener('pointermove', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      move(e);
    });
    slide.addEventListener('pointerleave', function () { slide.classList.remove('is-zooming'); });
  }
  function init() { document.querySelectorAll('.pp-gal .gallery__slide').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
